<div class="filter-title">
  <div class="filter-box">
    <p>Filter nach</p>
    <div>
      <cx-icon [type]="customIconTypes.BROWSE"></cx-icon>
    </div>
  </div>


</div>
<button
  #trigger
  class="btn btn-action btn-block dialog-trigger"
  (click)="launch()"
  >
  <cx-icon [type]="iconTypes.FILTER"></cx-icon>
  {{ 'productList.filterBy.label' | cxTranslate }}
</button>

<app-efa-active-facets></app-efa-active-facets>

@if (isOpen$ | async) {
  <app-efa-facet-list
    [isDialog]="hasTrigger"
    (closeList)="close()"
    [class.active]="isActive$ | async"
    [class.dialog]="hasTrigger"
  ></app-efa-facet-list>
}
